import Api from '@/api/index'

const state = {
  all: [],
}

const getters = {}

const actions = {
  async getPieRegularVariation(
    {
      commit, // eslint-disable-line no-unused-vars, params)
    },
    params
  ) {
    const data = await Api.Dashboard.getPieRegularVariation(params)
    if (data !== null) {
      return data
    }
    return []
  },
  async getPieCreateDelivered(
    {
      commit, // eslint-disable-line no-unused-vars, params)
    },
    params
  ) {
    const data = await Api.Dashboard.getPieCreateDelivered(params)
    if (data !== null) {
      return data
    }
    return []
  },
  async getBarCreateDelivered(
    {
      commit, // eslint-disable-line no-unused-vars, params)
    },
    params
  ) {
    const data = await Api.Dashboard.getBarCreateDelivered(params)
    if (data !== null) {
      return data
    }
    return []
  },

  async getBarInvoices(
    {
      commit, // eslint-disable-line no-unused-vars, params)
    },
    params
  ) {
    const data = await Api.Dashboard.getBarInvoices(params)
    if (data !== null) {
      return data
    }
    return []
  },

  async getLogs() {
    const data = await Api.Dashboard.getLogs()
    console.log(data)
    if (data !== null) {
      return data
    }
    return []
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
